export const gscTestQuery = (data) => {
    return fetch('/api/v1/domains/gsc-test-query/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};
